import React, { useRef } from "react";
import Slider from "react-slick";
import { IconButton } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./CardList.module.scss";

import { Card } from "../../common/Card";

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 8,
  slidesToScroll: 4,
  arrows: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 949,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const EaseCards = (props) => {
  const {
    title,
    list = [],
    type = "",
    showArrows = false,
    customStyles = { containerStyle: {} },
  } = props;

  const sliderRef = useRef(null);

  return (
    <div className={`${styles.container} ${customStyles.containerStyle}`}>
      <div className={styles.cardList}>
        <>
          <div className={styles.headerContainer}>
            {title && <h3>{title}</h3>}

            {showArrows && (
              <div className={styles.customArrows}>
                <IconButton
                  size="small"
                  onClick={() => sliderRef.current?.slickPrev()}
                >
                  <ArrowBackIosNew fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => sliderRef.current?.slickNext()}
                >
                  <ArrowForwardIos fontSize="small" />
                </IconButton>
              </div>
            )}
          </div>
          <div
            className={
              styles.imageSliderContainer +
              (type ? " " : " root-slider-container")
            }
          >
            <Slider {...settings} ref={sliderRef}>
              {list?.map((item, index) => (
                <div
                  className={styles.customSlideContainer}
                  key={`${type ? type : `card`}-${index}`}
                >
                  <Card {...item} type={type} item={item} index={index} />
                </div>
              ))}
            </Slider>
          </div>
        </>
      </div>
    </div>
  );
};

export default EaseCards;
